import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const WebFlowLanguageFilled = (props) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill="#fff">
      <Path d="M16.758 4.938h-3.042a1.934 1.934 0 0 0-1.927-1.948H4.925a1.93 1.93 0 0 0-1.927 1.927v6.864a1.93 1.93 0 0 0 1.927 1.928h6.864a1.93 1.93 0 0 0 1.927-1.928V8.834c1.458-.677 2.531-1.865 3.354-3.375a.365.365 0 0 0-.323-.532l.01.01Zm-6.469 1.604v3.708l-1-.125V8.532c-.073.01-.146.02-.208.02-.24 0-.48-.083-.677-.218.145.218.218.448.218.677 0 .604-.51 1.156-1.302 1.156-.885 0-1.614-.698-1.979-1.719l.656-.354c.282.73.698 1.115 1.157 1.115.364 0 .604-.25.604-.532a.581.581 0 0 0-.271-.479c-.219.136-.469.23-.708.271l-.396-.885c.469-.125 1.104-.355 1.104-.698 0-.146-.094-.271-.323-.271-.281 0-.646.208-.917.437l-.5-.76c.386-.365.865-.562 1.26-.562.699 0 1.261.541 1.261 1.229 0 .218-.062.416-.146.593.167.073.375.105.573.105.198 0 .407-.032.573-.094V6.542H8.55l-.156-.75h2.427l.156.75h-.708.021Z" />
      <Path d="M19.164 10.209h-4.948v2.416c0 .98-.802 1.781-1.781 1.781H10.32v.709c-1.604.198-2.635 1.469-3.385 3.25a.483.483 0 0 0 .437.677h2.959c0 1.093.875 1.958 1.947 1.958h6.907a1.952 1.952 0 0 0 1.948-1.948v-6.906a1.952 1.952 0 0 0-1.948-1.948l-.021.01Zm-1.167 7.635a.584.584 0 0 1-.406.156.525.525 0 0 1-.281-.083.506.506 0 0 1-.198-.24L16.81 17h-2.156l-.303.677a.572.572 0 0 1-.198.24.525.525 0 0 1-.28.083.602.602 0 0 1-.407-.156.473.473 0 0 1-.188-.375c0-.084.021-.167.063-.25l1.76-3.615a.679.679 0 0 1 .26-.28.77.77 0 0 1 .376-.095.77.77 0 0 1 .375.094.622.622 0 0 1 .26.281l1.76 3.615a.495.495 0 0 1-.114.625h-.02Z" />
      <Path d="M15.07 16.094h1.333l-.666-1.49-.667 1.49Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default WebFlowLanguageFilled
